import { render, staticRenderFns } from "./drawerBiangenghuoti.vue?vue&type=template&id=4e6b7cc6&scoped=true&"
import script from "./drawerBiangenghuoti.vue?vue&type=script&lang=js&"
export * from "./drawerBiangenghuoti.vue?vue&type=script&lang=js&"
import style0 from "./drawerBiangenghuoti.vue?vue&type=style&index=0&id=4e6b7cc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b7cc6",
  null
  
)

export default component.exports